import { FrontendConfig } from "../types";

const config: FrontendConfig = {
  pimsRxBasePath: "https://pimsrx-qa.covetrus.com",
  covetrusDomain: "covetrus.com",
  auth0ApiDomain: "covetrus-int.auth0.com",
  auth0ClientId: "Sz8RVMoGLCEVR0OaSCa5Xeztm5yPb6dK",
  logicalEnv: "qa",
};

export default config;
